import React, { useEffect, useState } from 'react'
import * as Styles from './index.module.scss'
import like from '@/images/like.png'
import down_black from '@images/ic_arrow_down.png'
import down_gray from '@/images/ic_arrow_down_gray.png'
import up_black from '@/images/ic_arrow_up_black.png'
import up_gray from '@/images/ic_arrow_up_gray.png'
import { Link } from 'gatsby'

const PAGE_SIZE = 3
function Relate(props) {
  const [pageIndex, changePageIndex] = useState(0)

  useEffect(() => {
    props.c_id && changePageIndex(0)
  }, [props])

  function prevPage() {
    changePageIndex(0)
  }

  function nextPage() {
    changePageIndex(3)
  }


  if (!props.list) return <></>
  return <div className={Styles.relate}>
    <h4 className={Styles.title}>相关晒单</h4>
    <div className={Styles.listPanel}>
      <div className={Styles.listBox}>
        {
          [...props.list].splice(pageIndex, PAGE_SIZE).map(item => {
            return <Link to={`/haul/${props.categoryId}/${item.productId}/${item.commentId}`}>
              <div className={Styles.relateDetail}>
                <img className={Styles.img} src={item.image?.thumbnail?.url || item.image?.full?.url} alt="relate img" />
                <div className={Styles.contentWrap}>
                  {item.content && <div className={Styles.content}>{item.content}</div>}
                  <div className={Styles.msgBox}>
                    <div className={Styles.nameWrap}>
                      <img className={Styles.avatar} src={item.userAvatar} alt="" />
                      <div className={Styles.name}>{item.userLabel}</div>
                    </div>
                    <div className={Styles.likes}>
                      <img className={Styles.icon} src={like} alt="" />
                      <div className={Styles.likeNum}>{item.likes}</div>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          })
        }
      </div>
      <div className={Styles.filp}>
        <img src={pageIndex === 0 ? up_gray : up_black} alt="prev" onClick={prevPage} />
        <img src={pageIndex === 3 ? down_gray : down_black} alt="next" onClick={nextPage} />
      </div>
    </div>

  </div>
}

export default Relate